import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Exchange = () => {
  const [currencies, setCurrencies] = useState([]);
  const [exchanges, setExchanges] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [commissionRate, setCommissionRate] = useState(0);
  const [newCommissionRate, setNewCommissionRate] = useState('');
  const [showCommissionForm, setShowCommissionForm] = useState(false);
  const [showCurrencyForm, setShowCurrencyForm] = useState(false);
  const [showExchangeForm, setShowExchangeForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [customerType, setCustomerType] = useState('walk_in');
  const [result, setResult] = useState(null);
  const [search, setSearch] = useState('');
  const [filterFromCurrency, setFilterFromCurrency] = useState('all');
  const [filterToCurrency, setFilterToCurrency] = useState('all');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [currencyForm, setCurrencyForm] = useState({ code: 'USD', buy_rate: '', sell_rate: '' });
  const [exchangeForm, setExchangeForm] = useState({
    customer_id: null, from_currency: 'USD', to_currency: 'IQD', amount: '', notes: ''
  });
  const token = localStorage.getItem('token');

  const currencyList = [
    { code: 'USD', name: 'دولار أمريكي' },
    { code: 'EUR', name: 'يورو' },
    { code: 'GBP', name: 'جنيه إسترليني' },
    { code: 'SAR', name: 'ريال سعودي' },
    { code: 'AED', name: 'درهم إماراتي' },
    { code: 'TRY', name: 'ليرة تركية' },
    { code: 'CAD', name: 'دولار كندي' },
  ];

  useEffect(() => {
    fetchCurrencies();
    fetchExchanges();
    fetchCustomers();
    fetchCommissionRate();
  }, []);

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/exchange/currencies', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCurrencies(response.data.currencies);
    } catch (err) { console.error(err); }
  };

  const fetchExchanges = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/exchange', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setExchanges(response.data.exchanges);
    } catch (err) { console.error(err); }
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/customers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(response.data.customers);
    } catch (err) { console.error(err); }
  };

  const fetchCommissionRate = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/exchange/commission', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCommissionRate(response.data.commission_rate);
    } catch (err) { console.error(err); }
  };

  const updateCommission = async (e) => {
    e.preventDefault();
    try {
      await axios.put('https://app.hayahost.net/api/exchange/commission',
        { commission_rate: newCommissionRate },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCommissionRate(newCommissionRate);
      setShowCommissionForm(false);
      alert('تم تحديث نسبة العمولة بنجاح!');
    } catch (err) { console.error(err); }
  };

  const handleCurrencySubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const selected = currencyList.find(c => c.code === currencyForm.code);
      await axios.post('https://app.hayahost.net/api/exchange/currencies', {
        name: selected ? selected.name : currencyForm.code,
        code: currencyForm.code,
        buy_rate: currencyForm.buy_rate,
        sell_rate: currencyForm.sell_rate
      }, { headers: { Authorization: `Bearer ${token}` } });
      setShowCurrencyForm(false);
      setCurrencyForm({ code: 'USD', buy_rate: '', sell_rate: '' });
      fetchCurrencies();
      alert('تم تحديث سعر العملة بنجاح!');
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const handleExchangeSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = {
        ...exchangeForm,
        customer_id: customerType === 'registered' ? exchangeForm.customer_id : null
      };
      const response = await axios.post('https://app.hayahost.net/api/exchange/exchange', data, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setResult(response.data.summary);
      fetchExchanges();
      setExchangeForm({ customer_id: null, from_currency: 'USD', to_currency: 'IQD', amount: '', notes: '' });
      setShowExchangeForm(false);
      setTimeout(() => setResult(null), 10000);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const calculateResult = () => {
    if (!exchangeForm.amount) return null;
    const currency = currencies.find(c =>
      c.code === (exchangeForm.from_currency === 'IQD' ? exchangeForm.to_currency : exchangeForm.from_currency)
    );
    if (!currency) return null;
    const buy_rate = parseFloat(currency.buy_rate);
    const sell_rate = parseFloat(currency.sell_rate);
    const amt = parseFloat(exchangeForm.amount);
    let resultAmount, rate, profit, profit_currency;

    if (exchangeForm.from_currency === 'IQD') {
      rate = sell_rate;
      resultAmount = amt / sell_rate;
      profit = resultAmount * (sell_rate - buy_rate);
      profit_currency = exchangeForm.to_currency;
    } else if (exchangeForm.to_currency === 'IQD') {
      rate = buy_rate;
      resultAmount = amt * buy_rate;
      profit = amt * (sell_rate - buy_rate);
      profit_currency = 'IQD';
    } else {
      const toCur = currencies.find(c => c.code === exchangeForm.to_currency);
      rate = buy_rate;
      resultAmount = toCur ? (amt * buy_rate) / parseFloat(toCur.sell_rate) : amt;
      profit = resultAmount * (toCur ? (parseFloat(toCur.sell_rate) - parseFloat(toCur.buy_rate)) : 0);
      profit_currency = exchangeForm.to_currency;
    }
    const commission = (amt * commissionRate) / 100;
    return { resultAmount: resultAmount.toFixed(2), rate, commission: commission.toFixed(2), profit: profit.toFixed(2), profit_currency };
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  // فلترة العمليات
  const filteredExchanges = exchanges.filter(e => {
    if (filterFromCurrency !== 'all' && e.from_currency !== filterFromCurrency) return false;
    if (filterToCurrency !== 'all' && e.to_currency !== filterToCurrency) return false;
    if (fromDate && new Date(e.created_at) < new Date(fromDate)) return false;
    if (toDate && new Date(e.created_at) > new Date(toDate + 'T23:59:59')) return false;
    if (search) {
      const s = search.toLowerCase();
      return (
        e.customer_name?.toLowerCase().includes(s) ||
        e.from_currency?.toLowerCase().includes(s) ||
        e.to_currency?.toLowerCase().includes(s) ||
        e.notes?.toLowerCase().includes(s) ||
        String(e.amount).includes(s)
      );
    }
    return true;
  });

  const totalOperations = exchanges.length;

  const statsByCurrency = filteredExchanges.reduce((acc, e) => {
    const fromCur = e.from_currency;
    const toCur = e.to_currency;
    if (!acc[fromCur]) acc[fromCur] = { buy: 0, sell: 0 };
    if (!acc[toCur]) acc[toCur] = { buy: 0, sell: 0 };
    if (fromCur === 'IQD') {
      acc[fromCur].sell += parseFloat(e.amount);
    } else {
      acc[fromCur].buy += parseFloat(e.amount);
    }
    return acc;
  }, {});

  const profitByCurrency = filteredExchanges.reduce((acc, e) => {
    const profitCur = e.profit_currency || (e.from_currency === 'IQD' ? e.to_currency : 'IQD');
    if (!acc[profitCur]) acc[profitCur] = 0;
    acc[profitCur] += parseFloat(e.profit || 0);
    return acc;
  }, {});

  const totalProfitInIQD = Object.entries(profitByCurrency).reduce((total, [currency, profit]) => {
    if (currency === 'IQD') return total + profit;
    const currencyData = currencies.find(c => c.code === currency);
    if (!currencyData) return total;
    return total + (profit * parseFloat(currencyData.buy_rate));
  }, 0);

  const totalBuy = Object.values(statsByCurrency).reduce((s, v) => s + v.buy, 0);
  const totalSell = Object.values(statsByCurrency).reduce((s, v) => s + v.sell, 0);
  const totalProfitIQD = profitByCurrency['IQD'] || 0;

  const calc = calculateResult();

  return (
    <div style={styles.container}>
      <div style={styles.navbar}>
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar}>
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={styles.sideItem}>💸 الحوالات</a>
          <a href="/exchange" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
        </div>

        <div style={styles.content}>

          {result && (
            <div style={styles.resultCard}>
              <h3 style={styles.resultTitle}>✅ تم تنفيذ الصرف بنجاح!</h3>
              <div style={styles.resultGrid}>
                {Object.entries(result).map(([key, val]) => (
                  <div key={key} style={styles.resultItem}>
                    <span style={styles.resultLabel}>{key}</span>
                    <span style={styles.resultValue}>{val}</span>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* المربعات الأربعة */}
          <div style={styles.bigStatsGrid}>
            <div style={{...styles.bigStatCard, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}}>
              <div style={styles.bigStatIcon}>📊</div>
              <div style={styles.bigStatNumber}>{totalOperations}</div>
              <div style={styles.bigStatLabel}>إجمالي العمليات</div>
            </div>
            <div style={{...styles.bigStatCard, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}}>
              <div style={styles.bigStatIcon}>💰</div>
              <div style={styles.bigStatNumber}>{totalProfitIQD.toLocaleString()}</div>
              <div style={styles.bigStatLabel}>إجمالي الأرباح IQD</div>
            </div>
            <div style={{...styles.bigStatCard, background: 'linear-gradient(135deg, #e65100, #f57c00)'}}>
              <div style={styles.bigStatIcon}>📥</div>
              <div style={styles.bigStatNumber}>{totalBuy.toLocaleString()}</div>
              <div style={styles.bigStatLabel}>إجمالي الشراء</div>
            </div>
            <div style={{...styles.bigStatCard, background: 'linear-gradient(135deg, #880e4f, #c2185b)'}}>
              <div style={styles.bigStatIcon}>📤</div>
              <div style={styles.bigStatNumber}>{totalSell.toLocaleString()}</div>
              <div style={styles.bigStatLabel}>إجمالي البيع IQD</div>
            </div>
          </div>

          {/* الإجماليات المفصلة */}
          {Object.keys(statsByCurrency).length > 0 && (
            <div style={styles.detailedStats}>
              <div style={styles.detailedStatsGrid}>
                <div>
                  <h3 style={styles.detailedTitle}>📥📤 الشراء والبيع بكل عملة</h3>
                  <div style={styles.detailedGrid}>
                    {Object.entries(statsByCurrency).map(([currency, data]) => (
                      (data.buy > 0 || data.sell > 0) && (
                        <div key={currency} style={styles.detailedCard}>
                          <div style={styles.detailedCurrency}>{currency}</div>
                          {data.buy > 0 && (
                            <div style={styles.detailedRow}>
                              <span style={styles.detailedLabel}>📥 إجمالي الشراء</span>
                              <span style={styles.detailedValue}>{data.buy.toLocaleString()} {currency}</span>
                            </div>
                          )}
                          {data.sell > 0 && (
                            <div style={styles.detailedRow}>
                              <span style={styles.detailedLabel}>📤 إجمالي البيع</span>
                              <span style={styles.detailedValue}>{data.sell.toLocaleString()} {currency}</span>
                            </div>
                          )}
                        </div>
                      )
                    ))}
                  </div>
                </div>
                <div>
                  <h3 style={styles.detailedTitle}>💰 إجمالي الأرباح بكل عملة</h3>
                  <div style={styles.detailedGrid}>
                    {Object.entries(profitByCurrency).map(([currency, profit]) => (
                      profit > 0 && (
                        <div key={currency} style={styles.profitCard}>
                          <div style={styles.detailedCurrency}>{currency}</div>
                          <div style={styles.detailedRow}>
                            <span style={styles.detailedLabel}>💰 إجمالي الأرباح</span>
                            <span style={{...styles.detailedValue, color: '#2e7d32', fontSize: '16px'}}>
                              {profit.toLocaleString()} {currency}
                            </span>
                          </div>
                        </div>
                      )
                    ))}
                    <div style={styles.totalIQDCard}>
                      <span style={styles.totalIQDLabel}>🏆 إجمالي كل الأرباح بالدينار</span>
                      <span style={styles.totalIQDValue}>{totalProfitInIQD.toLocaleString()} IQD</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* إعداد العمولة */}
          <div style={styles.commissionBar}>
            <span style={styles.commissionText}>💰 نسبة العمولة الحالية: <strong>{commissionRate}%</strong></span>
            <button style={styles.commissionBtn} onClick={() => setShowCommissionForm(!showCommissionForm)}>⚙️ تغيير النسبة</button>
          </div>

          {showCommissionForm && (
            <div style={styles.formCard}>
              <h3 style={styles.formTitle}>⚙️ تحديث نسبة العمولة</h3>
              <form onSubmit={updateCommission} style={{display: 'flex', gap: '10px', alignItems: 'flex-end'}}>
                <div style={styles.inputGroup}>
                  <label style={styles.label}>النسبة المئوية %</label>
                  <input style={{...styles.input, width: '200px'}} type="number" step="0.1"
                    value={newCommissionRate} onChange={e => setNewCommissionRate(e.target.value)}
                    placeholder="مثال: 0.5" required />
                </div>
                <button style={styles.submitBtn} type="submit">حفظ</button>
              </form>
            </div>
          )}

          {/* أسعار العملات */}
          <div style={styles.section}>
            <div style={styles.header}>
              <h2 style={styles.pageTitle}>💱 أسعار العملات مقابل الدينار</h2>
              <button style={styles.addBtn} onClick={() => setShowCurrencyForm(!showCurrencyForm)}>
                {showCurrencyForm ? 'إلغاء' : '+ تحديث/إضافة سعر'}
              </button>
            </div>

            {showCurrencyForm && (
              <div style={styles.formCard}>
                <h3 style={styles.formTitle}>تحديث سعر العملة مقابل الدينار العراقي</h3>
                <form onSubmit={handleCurrencySubmit}>
                  <div style={styles.formGrid}>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>اختر العملة</label>
                      <select style={styles.input} value={currencyForm.code}
                        onChange={e => setCurrencyForm({...currencyForm, code: e.target.value})}>
                        {currencyList.map(c => (
                          <option key={c.code} value={c.code}>{c.name} - {c.code}</option>
                        ))}
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>سعر الشراء (نشتري منه)</label>
                      <input style={styles.input} type="number" value={currencyForm.buy_rate}
                        onChange={e => setCurrencyForm({...currencyForm, buy_rate: e.target.value})}
                        placeholder="1480" required />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>سعر البيع (نبيع له)</label>
                      <input style={styles.input} type="number" value={currencyForm.sell_rate}
                        onChange={e => setCurrencyForm({...currencyForm, sell_rate: e.target.value})}
                        placeholder="1485" required />
                    </div>
                  </div>
                  <button style={styles.submitBtn} type="submit" disabled={loading}>
                    {loading ? 'جاري الحفظ...' : 'حفظ السعر'}
                  </button>
                </form>
              </div>
            )}

            <div style={styles.currencyGrid}>
              {currencies.map((c, i) => (
                <div key={i} style={styles.currencyCard}>
                  <div style={styles.currencyCode}>{c.code}</div>
                  <div style={styles.currencyName}>{c.name}</div>
                  <div style={styles.ratesRow}>
                    <div style={styles.rateBox}>
                      <span style={styles.rateLabel}>شراء</span>
                      <span style={styles.rateValue}>{parseFloat(c.buy_rate).toLocaleString()}</span>
                    </div>
                    <div style={{...styles.rateBox, background: '#e8f5e9'}}>
                      <span style={styles.rateLabel}>بيع</span>
                      <span style={{...styles.rateValue, color: '#2e7d32'}}>{parseFloat(c.sell_rate).toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* عملية صرف */}
          <div style={styles.section}>
            <div style={styles.header}>
              <h2 style={styles.pageTitle}>💰 تنفيذ عملية صرف</h2>
              <button style={styles.addBtn} onClick={() => setShowExchangeForm(!showExchangeForm)}>
                {showExchangeForm ? 'إلغاء' : '+ عملية صرف جديدة'}
              </button>
            </div>

            {showExchangeForm && (
              <div style={styles.formCard}>
                <h3 style={styles.formTitle}>عملية صرف جديدة</h3>
                <div style={styles.customerTypeRow}>
                  <button type="button" style={customerType === 'walk_in' ? styles.typeActive : styles.typeInactive} onClick={() => setCustomerType('walk_in')}>🚶 زبون عابر</button>
                  <button type="button" style={customerType === 'registered' ? styles.typeActive : styles.typeInactive} onClick={() => setCustomerType('registered')}>👤 زبون مسجل</button>
                </div>
                <form onSubmit={handleExchangeSubmit}>
                  <div style={styles.formGrid}>
                    {customerType === 'registered' && (
                      <div style={{...styles.inputGroup, }}>
                        <label style={styles.label}>اختر العميل</label>
                        <select style={styles.input} value={exchangeForm.customer_id}
                          onChange={e => setExchangeForm({...exchangeForm, customer_id: e.target.value})} required>
                          <option value="">-- اختر العميل --</option>
                          {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                        </select>
                      </div>
                    )}
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>المبلغ</label>
                      <input style={styles.input} type="number" value={exchangeForm.amount}
                        onChange={e => setExchangeForm({...exchangeForm, amount: e.target.value})} placeholder="0" required />
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>من عملة</label>
                      <select style={styles.input} value={exchangeForm.from_currency}
                        onChange={e => setExchangeForm({...exchangeForm, from_currency: e.target.value})}>
                        <option value="IQD">دينار IQD</option>
                        {currencyList.map(c => <option key={c.code} value={c.code}>{c.name} - {c.code}</option>)}
                      </select>
                    </div>
                    <div style={styles.inputGroup}>
                      <label style={styles.label}>إلى عملة</label>
                      <select style={styles.input} value={exchangeForm.to_currency}
                        onChange={e => setExchangeForm({...exchangeForm, to_currency: e.target.value})}>
                        <option value="IQD">دينار IQD</option>
                        {currencyList.map(c => <option key={c.code} value={c.code}>{c.name} - {c.code}</option>)}
                      </select>
                    </div>
                    {calc && (
                      <div style={{...styles.previewBox, }}>
                        <div style={styles.previewRow}>
                          <span>📊 {exchangeForm.amount} {exchangeForm.from_currency}</span>
                          <span style={styles.arrow}>←</span>
                          <span style={styles.previewResult}>{calc.resultAmount} {exchangeForm.to_currency}</span>
                        </div>
                        <div style={styles.previewRow}>
                          <span style={styles.previewRate}>السعر: {calc.rate.toLocaleString()}</span>
                          <span style={styles.previewCommission}>العمولة ({commissionRate}%): {calc.commission} {exchangeForm.from_currency}</span>
                          <span style={{color: '#2e7d32', fontSize: '13px', fontWeight: 'bold'}}>
                            💰 الربح: {parseFloat(calc.profit).toLocaleString()} {calc.profit_currency}
                          </span>
                        </div>
                      </div>
                    )}
                    <div style={{...styles.inputGroup, }}>
                      <label style={styles.label}>ملاحظات</label>
                      <input style={styles.input} value={exchangeForm.notes}
                        onChange={e => setExchangeForm({...exchangeForm, notes: e.target.value})} placeholder="أي ملاحظات" />
                    </div>
                  </div>
                  <button style={styles.submitBtn} type="submit" disabled={loading}>
                    {loading ? 'جاري التنفيذ...' : '💱 تنفيذ الصرف'}
                  </button>
                </form>
              </div>
            )}

            {/* البحث والفلاتر */}
            <div style={styles.searchCard}>
              <div style={styles.searchRow}>
                <input style={styles.searchInput} value={search}
                  onChange={e => setSearch(e.target.value)}
                  placeholder="🔍 بحث باسم العميل، العملة، المبلغ، الملاحظات..." />
                <button style={styles.clearBtn} onClick={() => { setSearch(''); setFilterFromCurrency('all'); setFilterToCurrency('all'); setFromDate(''); setToDate(''); }}>
                  مسح
                </button>
              </div>
              <div style={styles.filtersRow}>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>من عملة</label>
                  <select style={styles.filterSelect} value={filterFromCurrency} onChange={e => setFilterFromCurrency(e.target.value)}>
                    <option value="all">الكل</option>
                    <option value="IQD">IQD</option>
                    {currencyList.map(c => <option key={c.code} value={c.code}>{c.code}</option>)}
                  </select>
                </div>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>إلى عملة</label>
                  <select style={styles.filterSelect} value={filterToCurrency} onChange={e => setFilterToCurrency(e.target.value)}>
                    <option value="all">الكل</option>
                    <option value="IQD">IQD</option>
                    {currencyList.map(c => <option key={c.code} value={c.code}>{c.code}</option>)}
                  </select>
                </div>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>من تاريخ</label>
                  <input style={styles.filterDate} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
                </div>
                <div style={styles.filterGroup}>
                  <label style={styles.filterLabel}>إلى تاريخ</label>
                  <input style={styles.filterDate} type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
                </div>
                <div style={styles.filterResult}>
                  <span style={styles.filterResultText}>النتائج: <strong>{filteredExchanges.length}</strong> من {exchanges.length}</span>
                </div>
              </div>
            </div>

            <div style={styles.tableCard}>
              <table style={styles.table}>
                <thead>
                  <tr style={styles.tableHead}>
                    <th style={styles.th}>العميل</th>
                    <th style={styles.th}>من</th>
                    <th style={styles.th}>إلى</th>
                    <th style={styles.th}>المبلغ</th>
                    <th style={styles.th}>السعر</th>
                    <th style={styles.th}>الربح</th>
                    <th style={styles.th}>العمولة %</th>
                    <th style={styles.th}>التاريخ والوقت</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredExchanges.map((e, i) => {
                    const profitCur = e.profit_currency || (e.from_currency === 'IQD' ? e.to_currency : 'IQD');
                    return (
                      <tr key={e.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                        <td style={styles.td}>{e.customer_name || 'زبون عابر'}</td>
                        <td style={styles.td}>{e.from_currency}</td>
                        <td style={styles.td}>{e.to_currency}</td>
                        <td style={styles.td}>{parseFloat(e.amount).toLocaleString()} {e.from_currency}</td>
                        <td style={styles.td}>{parseFloat(e.rate).toLocaleString()}</td>
                        <td style={{...styles.td, color: '#2e7d32', fontWeight: 'bold'}}>
                          {parseFloat(e.profit).toLocaleString()} {profitCur}
                        </td>
                        <td style={{...styles.td, color: '#e65100'}}>
                          {e.commission_rate}% = {parseFloat(e.commission_amount || 0).toFixed(2)} {e.from_currency}
                        </td>
                        <td style={{...styles.td, fontSize: '12px', color: '#666'}}>
                          {formatDateTime(e.created_at)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
                <tfoot>
                  <tr style={styles.totalRow}>
                    <td style={styles.totalTd} colSpan="5"><strong>إجمالي الأرباح ({filteredExchanges.length} عملية)</strong></td>
                    <td style={{...styles.totalTd, color: '#2e7d32'}}>
                      {Object.entries(profitByCurrency).map(([cur, profit]) => (
                        profit > 0 && <div key={cur}><strong>💰 {profit.toLocaleString()} {cur}</strong></div>
                      ))}
                      <div style={{marginTop: '5px', paddingTop: '5px', borderTop: '1px solid #a5d6a7'}}>
                        <strong style={{color: '#1b5e20'}}>🏆 الإجمالي: {totalProfitInIQD.toLocaleString()} IQD</strong>
                      </div>
                    </td>
                    <td style={styles.totalTd} colSpan="2"></td>
                  </tr>
                </tfoot>
              </table>
              {filteredExchanges.length === 0 && <div style={styles.empty}>لا توجد نتائج</div>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0' },
  content: { flex: 1, padding: '30px' },
  bigStatsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '20px', marginBottom: '20px' },
  bigStatCard: { borderRadius: '12px', padding: '25px', color: 'white', textAlign: 'center' },
  bigStatIcon: { fontSize: '30px', marginBottom: '10px' },
  bigStatNumber: { fontSize: '26px', fontWeight: 'bold', marginBottom: '5px' },
  bigStatLabel: { fontSize: '13px', opacity: 0.9 },
  detailedStats: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  detailedStatsGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' },
  detailedTitle: { color: '#1a237e', marginBottom: '15px', fontSize: '15px', borderBottom: '2px solid #e3f2fd', paddingBottom: '8px' },
  detailedGrid: { display: 'flex', flexDirection: 'column', gap: '10px' },
  detailedCard: { background: '#f8f9fa', borderRadius: '10px', padding: '12px' },
  profitCard: { background: '#e8f5e9', borderRadius: '10px', padding: '12px', border: '1px solid #a5d6a7' },
  totalIQDCard: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', borderRadius: '10px', padding: '15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  totalIQDLabel: { color: 'white', fontSize: '13px', fontWeight: 'bold' },
  totalIQDValue: { color: '#a5d6a7', fontSize: '18px', fontWeight: 'bold' },
  detailedCurrency: { fontSize: '20px', fontWeight: 'bold', color: '#1a237e', marginBottom: '8px' },
  detailedRow: { display: 'flex', justifyContent: 'space-between', marginBottom: '4px' },
  detailedLabel: { fontSize: '12px', color: '#666' },
  detailedValue: { fontSize: '14px', fontWeight: 'bold', color: '#333' },
  commissionBar: { background: 'white', borderRadius: '10px', padding: '15px 20px', marginBottom: '20px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  commissionText: { fontSize: '14px', color: '#333' },
  commissionBtn: { background: '#e65100', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  resultCard: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', borderRadius: '12px', padding: '20px', marginBottom: '20px', color: 'white' },
  resultTitle: { marginBottom: '15px', fontSize: '16px' },
  resultGrid: { display: 'flex', gap: '20px', alignItems: 'center', flexWrap: 'wrap' },
  resultItem: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '5px' },
  resultLabel: { fontSize: '12px', opacity: 0.8 },
  resultValue: { fontSize: '16px', fontWeight: 'bold' },
  section: { marginBottom: '30px' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px' },
  addBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  formTitle: { marginBottom: '15px', color: '#1a237e' },
  customerTypeRow: { display: 'flex', gap: '10px', marginBottom: '20px' },
  typeActive: { flex: 1, padding: '12px', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  typeInactive: { flex: 1, padding: '12px', background: '#f5f5f5', color: '#666', border: '2px solid #e0e0e0', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: {},
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  previewBox: { background: '#e3f2fd', borderRadius: '8px', padding: '15px', display: 'flex', flexDirection: 'column', gap: '8px' },
  previewRow: { display: 'flex', alignItems: 'center', gap: '15px', fontSize: '14px', color: '#1a237e', flexWrap: 'wrap' },
  arrow: { fontSize: '20px' },
  previewResult: { fontSize: '18px', fontWeight: 'bold', color: '#2e7d32' },
  previewRate: { fontSize: '12px', color: '#666' },
  previewCommission: { fontSize: '12px', color: '#e65100', fontWeight: 'bold' },
  submitBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  currencyGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(180px, 1fr))', gap: '15px', marginBottom: '20px' },
  currencyCard: { background: 'white', borderRadius: '12px', padding: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', textAlign: 'center' },
  currencyCode: { fontSize: '24px', fontWeight: 'bold', color: '#1a237e', marginBottom: '5px' },
  currencyName: { fontSize: '12px', color: '#666', marginBottom: '12px' },
  ratesRow: { display: 'flex', gap: '8px' },
  rateBox: { flex: 1, background: '#fff3e0', borderRadius: '8px', padding: '8px', display: 'flex', flexDirection: 'column', alignItems: 'center' },
  rateLabel: { fontSize: '11px', color: '#666' },
  rateValue: { fontSize: '14px', fontWeight: 'bold', color: '#e65100' },
  searchCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '15px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  searchRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  searchInput: { flex: 1, padding: '10px 15px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  clearBtn: { background: '#666', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  filtersRow: { display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' },
  filterGroup: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filterLabel: { fontSize: '12px', color: '#666', fontWeight: 'bold' },
  filterSelect: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterDate: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterResult: { display: 'flex', alignItems: 'center' },
  filterResultText: { fontSize: '13px', color: '#666' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'right', fontSize: '13px' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '10px 15px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  totalRow: { background: '#e8f5e9' },
  totalTd: { padding: '12px 15px', fontSize: '13px', color: '#1a237e' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
};

export default Exchange;